interface eventMapType {
    event: EventHandler,
    type: string
}

type EventHandler<T extends any[] = any[]> = (...args: T) => void

export default class Mitt {
    private static eventList: eventMapType[] = []

    static emit(type:string): void {
        if(this.eventList.length === 0 ) return;
        this.eventList.forEach((eventMap => {
            if(eventMap.type === type) {
                eventMap.event()
            }
        }))
    }


    static on(type: string, event: EventHandler): void {
        this.eventList.push({ event, type })
    }

    static off(type: string): void {
        const filterEventList = this.eventList.filter(eventMap => {
            return eventMap.type !== type
        })

        this.eventList = filterEventList
    } 
}